module.exports = __webpack_public_path__ + "img/3-mob.3f0d7e0b.svg";